<h3 mat-dialog-title>{{ jobOrderDetail?.code }}</h3>
<mat-dialog-content class="job-order-detail-dialog-content">
  <h2>General info</h2>

  <div class="field">
    <span class="field-label">Name</span>
    <span class="field-value">{{ jobOrderDetail?.code }}</span>
  </div>

  <div class="field">
    <span class="field-label">Delivery Date</span>
    <span class="field-value">{{
      jobOrderDetail?.deliveryDate | date: "short"
    }}</span>
  </div>

  <div class="field">
    <span class="field-label">Description</span>
    <span class="field-value">{{ jobOrderDetail?.description }}</span>
  </div>

  <div class="field">
    <span class="field-label">Difficulty</span>
    <span class="field-value">{{ jobOrderDetail?.difficulty }}</span>
  </div>

  <div class="field">
    <span class="field-label">Note</span>
    <span class="field-value">{{ jobOrderDetail?.note }}</span>
  </div>

  <h2>Efficency</h2>

  <div class="field">
    <span class="field-label">Start</span>
    <span class="field-value">{{
      jobOrderDetail?.startDate | date: "short"
    }}</span>
  </div>

  <div class="field">
    <span class="field-label">End</span>
    <span class="field-value">{{
      jobOrderDetail?.endDate | date: "short"
    }}</span>
  </div>

  <div class="field">
    <span class="field-label">Total time</span>
    <span class="field-value">{{
      jobOrderDetail?.totalTimeAsHHmmss
    }}</span>
  </div>

  <div class="field">
    <span class="field-label">Total lost time</span>
    <span class="field-value">{{
      jobOrderDetail?.totalLostTimeAsHHmmss
    }}</span>
  </div>

  <div class="field">
    <span class="field-label">Effective time</span>
    <span class="field-value">{{
      jobOrderDetail?.effectiveWorkingTimeAsHHmmss
    }}</span>
  </div>

  <div class="field">
    <span class="field-label">Efficency percentage</span>
    <span class="field-value">Not available</span>
  </div>

  <div class="chart-container" *ngIf="chartData">
    <google-chart [data]="chartData"></google-chart>
  </div>
</mat-dialog-content>
